<div class="text-center" [ngClass]="class()">
	<div class="fst-italic text-secondary px-3 py-2" [innerHTML]="message()">
	</div>

	<ng-content></ng-content>
</div>
